import { useLocation } from "react-router-dom";
import STUtils from "../../assets/styles/utility.module.scss";
import { routes } from "../../router/Router";
import { CONTENT_TYPE, TAppContentType } from "../../types/TAppContentType";
import { getSubdomain } from "../../utils/getSubdomain";
import BottomNavigationBar from "../organisms/BottomNavigationBar";
import InfoArticleList from "../organisms/InfoArticleList";
import BaseHead from "../templates/BaseHead";
import { useEffect, useState } from "react";
import TApiResult from "../../types/api/TApiResult";
import { fetchCategories, TApiCategoriesResult } from "../../utils/api/fetchCategories";
import { categorySummary } from "../../types/categorySummary";

const InformationList: React.FC = () => {
  const query = new URLSearchParams(useLocation().search);
  const page = query.get("page") ? Number(query.get("page")) : 1;
  const list = query.get("list") ?? undefined;
  const category = query.get("category")
    ? Number(query.get("category"))
    : undefined;
  const title = query.get("title") ?? undefined;
  const categorySlug = query.get("category_slug") ?? undefined;
  const contentTypeIds: TAppContentType[] = [
    CONTENT_TYPE.information,
  ]
  const [categories, setCategories] = useState<categorySummary[]>([]);

  if(!list){
    contentTypeIds.push(CONTENT_TYPE.video);
  }

  useEffect(() => {
    // 全カテゴリ（親+子）を取得して階層的にドロップダウンに表示
    fetchCategories().then((res: TApiResult & TApiCategoriesResult) => {
      if (!res.isSuccess || !res.result) {
        return;
      }
      const newCategories: categorySummary[] = [{ id: 0, name: "すべて", linkUrl: "" }];

      // 親カテゴリ（parent が null）と子カテゴリを分離
      const parents = res.result.filter((v) => !v.parent);
      const children = res.result.filter((v) => v.parent);

      // 親カテゴリの下に子カテゴリを配置
      parents.forEach((parent) => {
        newCategories.push({
          id: parent.id,
          name: parent.name,
          linkUrl: parent.slug
            ? `category_slug=${parent.slug}`
            : `category=${parent.id}`,
        });
        // この親に属する子カテゴリを追加
        children
          .filter((child) => child.parent?.id === parent.id)
          .forEach((child) => {
            newCategories.push({
              id: child.id,
              name: `\u3000${child.name}`,
              linkUrl: child.slug
                ? `category_slug=${child.slug}`
                : `category=${child.id}`,
            });
          });
      });

      setCategories(newCategories);
    });
  }, []);

  const subdomain = getSubdomain(window.location.hostname);
  return (
    <BaseHead
      title={routes.informations.title}
      login={true}
      subdomain={subdomain}
      hasBackground={true}
      hasNavigationBar={true}
      hasBackButton={true}
    >
      <section className={STUtils.container_large}>
        <InfoArticleList
          requestPage={page}
          requestCategory={category}
          requestTitle={title}
          requestCategorySlug={categorySlug}
          contentTypeIds={contentTypeIds}
          categories={categories}
          requestList={list}
        />
        <div>
          <BottomNavigationBar />
        </div>
      </section>
    </BaseHead>
  );
};

export default InformationList;
